var exports = {
  "k": "xdde3148b--2d4e7d--container",
};

module.exports = exports;
